import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  phone: '',
  vehicle_number: '',
  bank_account: '',
};

export const FormBulkUpdate = ({ data, onSubmit, onClose }) => {
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const [
    {
      isLoading,
      name,
      phone,
      vehicle_number,
      bank_account,
    },
    setState,
  ] = React.useState(initialState);

  const $onSave = async (c) => {
    const payload = {
      name,
      phone,
      vehicle_number,
      bank_account,
    };

    onSubmit(payload);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, [isLoading]);

  React.useEffect(() => {
    if (!data) return;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    setState((prevState) => ({
      ...prevState,
      name: data?.name,
      phone: data?.phone,
      vehicle_number: data?.vehicle_number,
      bank_account: data?.bank_account,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div className="row m-0">
        {dummy?.map((d, i) => (
          <div key={i} className="col-md-6">
            <SkeletonsForm count={1} key={i} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="px-3 pt-4 pb-3 bg-white my-3 border rounded-2">
      <div className="row text-start">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 ">
            Perbaharui
          </div>
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={name}
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, name: e.target.value }))
            }
            error={StateForm?.errors?.name}
            type="text"
            label="Nama Driver"
          />

          <Form.Input
            label="No. Handphone"
            type="text"
            value={phone}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                phone: e.target.value,
              }))
            }
            error={StateForm?.errors?.phone}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            label="No. Polisi Kendaraan"
            type="text"
            value={vehicle_number}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                vehicle_number: e.target.value,
              }))
            }
            error={StateForm?.errors?.vehicle_number}
          />

          <Form.Input
            label="Nama Bank &amp; No. Rekening"
            type="text"
            value={bank_account}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                bank_account: e.target.value,
              }))
            }
            error={StateForm?.errors?.bank_account}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 border-top mt-4 pt-3 mb-0">
        <div
          className="btn btn-primary btn-sm rounded-2 px-5 "
          onClick={$onSave}
        >
          Simpan Perubahan
        </div>
        <div className="btn btn-danger btn-sm rounded-2 px-5" onClick={onClose}>
          Batal
        </div>
      </div>
    </div>
  );
};
